import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 113,
	height: 82,
	viewBox: "0 0 113 82",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_43_239)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M106.617 6.73186C104.602 4.62022 101.756 3.30872 98.6035 3.30872H14.3965C11.244 3.30872 8.40446 4.62022 6.38305 6.73186C4.47596 8.72319 3.30884 11.4244 3.30884 14.3963V67.416C3.30884 70.388 4.47596 73.0892 6.38305 75.0805C8.39844 77.1922 11.244 78.5037 14.3905 78.5037H98.5975C101.75 78.5037 104.59 77.1922 106.611 75.0805C108.518 73.0892 109.685 70.388 109.685 67.416V14.3963C109.685 11.4244 108.518 8.72319 106.611 6.73186H106.617Z",
				stroke: "white",
				strokeWidth: 6.61769,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M106.617 6.73186C104.602 4.62022 101.756 3.30872 98.6035 3.30872H14.3965C11.244 3.30872 8.40446 4.62022 6.38305 6.73186C4.47596 8.72319 3.30884 11.4244 3.30884 14.3963V67.416C3.30884 70.388 4.47596 73.0892 6.38305 75.0805C8.39844 77.1922 11.244 78.5037 14.3905 78.5037H98.5975C101.75 78.5037 104.59 77.1922 106.611 75.0805C108.518 73.0892 109.685 70.388 109.685 67.416V14.3963C109.685 11.4244 108.518 8.72319 106.611 6.73186H106.617Z",
				fill: "url(#paint0_linear_43_239)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M106.617 6.73186L67.5967 40.9032L61.0271 46.6606C58.4402 48.9286 54.5718 48.9286 51.9849 46.6606L45.4154 40.9032L6.38306 6.73186C8.39844 4.62022 11.244 3.30872 14.3965 3.30872H98.6035C101.756 3.30872 104.596 4.62022 106.617 6.73186Z",
				fill: "#E8E8E8"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_43_239",
		x1: 3.30884,
		y1: 40.9032,
		x2: 109.691,
		y2: 40.9032,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D0CFCF" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#989898"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_43_239",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 113,
			height: 81.8127,
			fill: "white"
		})
	})] })]
});
export default SvgMail;
